import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import CRMApi from '../../../Api/CRM/CRMApi';
import { GetPaymentMethodResponse } from '../../../Api/CRM/Responses/PaymentMethodResponse';
import SweetAlert from '../../elements/alerts/SweetAlert';
import Card from '../../elements/common/Card';
import SubmitButton from '../../elements/formElements/SubmitButton';
import handleValidationErrors, { ValidationErrors } from '../../helpers/ResponseErrorHelper';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';
import useSmartField, { FieldChangeCallback } from '../../hooks/useSmartField';

function PaymentMethodEdit() {
    const history = useHistory();
    const { id } = useNumberParams();
    const [paymentMethod, setPaymentMethod] = useState<GetPaymentMethodResponse>({} as any);
    const onChange: FieldChangeCallback = (name, value) => setPaymentMethod((prev) => ({ ...prev, [name]: value }));
    const [errors, setErrors] = useState<ValidationErrors>({});
    const Field = useSmartField({ onChange, errors });
    const url = `payment_method/${id}`;

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        try {
            await SweetAlert.loader(CRMApi.patch(url, paymentMethod));
            await SweetAlert.success('Payment Method updated correctly');
            history.push('/payment_methods');
        } catch (error) {
            handleValidationErrors(error, setErrors);
        }
    };

    useOnce(async () => setPaymentMethod((await CRMApi.get(url)).data));

    return (
        <Card title="Update Payment Method">
            <form onSubmit={handleSubmit} autoComplete="do-not-autofill">
                <Field type="text" name="name" value={paymentMethod.name} />
                <Field type="text" name="transaction_currency" value={paymentMethod.transaction_currency} />
                <Field type="number" name="user_fixed_fee" value={paymentMethod.user_fixed_fee} />
                <Field type="text" name="user_fixed_fee_currency" value={paymentMethod.user_fixed_fee_currency} />
                <Field type="number" name="user_percent_fee" value={paymentMethod.user_percent_fee} />
                <Field type="number" name="system_fixed_fee" value={paymentMethod.system_fixed_fee} />
                <Field type="text" name="system_fixed_fee_currency" value={paymentMethod.system_fixed_fee_currency} />
                <Field type="number" name="system_percent_fee" value={paymentMethod.system_percent_fee} />
                <Field
                    type="checkbox"
                    name="is_web"
                    value={paymentMethod.is_web}
                    disabled={paymentMethod.is_manual_only}
                />
                <Field
                    type="checkbox"
                    name="is_mobile"
                    value={paymentMethod.is_mobile}
                    disabled={paymentMethod.is_manual_only}
                />
                <Field type="checkbox" name="is_disabled" value={paymentMethod.is_disabled} />
                <Field type="text" name="data" value={String(paymentMethod.data ?? '')} />
                <Field type="number" name="order" value={paymentMethod.order} />
                <Field type="number" name="max_payment" value={paymentMethod.max_payment} />
                <Field type="number" name="min_payment" value={paymentMethod.min_payment} />
                <SubmitButton label="Save" />
            </form>
        </Card>
    );
}

export default PaymentMethodEdit;
